/**
 * Card Variants
 *
 * CVA variants for the Card component.
 * Exported separately to comply with React Fast Refresh requirements.
 *
 * @see Card.tsx for component implementation
 */

import {cva} from'class-variance-authority';

export const cardVariants = cva(
"rounded-apple-xl backdrop-blur transition-all duration-[var(--duration-morph)] ease-[var(--ease-liquid)] border border-transparent",
 {
 variants: {
 variant: {
 default:"bg-card text-card-foreground shadow-apple-md border-border/50",
 elevated:"bg-card text-card-foreground shadow-apple-xl animate-future-breathing-glow border-border/50",
 outlined:"bg-card text-card-foreground shadow-md ring-1 ring-primary/20",
 subtle:"bg-muted/30 text-card-foreground shadow-sm",
 glowing:"bg-card text-card-foreground shadow-apple-md animate-future-breathing-glow border border-primary/30",
 glass:"liquid-glass border-[hsl(var(--liquid-glass-border-medium))] shadow-liquid-glass",
"liquid-glass":"liquid-glass border-[hsl(var(--liquid-glass-border-medium))] shadow-liquid-glass",
"liquid-glass-thin":"liquid-glass-thin border-[hsl(var(--liquid-glass-border-light))] shadow-liquid-glass-sm",
"liquid-glass-thick":"liquid-glass-thick border-[hsl(var(--liquid-glass-border-medium))] shadow-liquid-glass-lg",
"liquid-glass-specular":"liquid-glass liquid-glass-specular border-[hsl(var(--liquid-glass-border-medium))] shadow-liquid-glass",
 tangi:"bg-gradient-to-br from-card/90 to-card/50 backdrop-blur-xl border-border/20 shadow-apple-xl"
 },
 padding: {
 none:"p-0",
 sm:"p-3 sm:p-4",
 md:"p-4 sm:p-6",
 lg:"p-6 sm:p-8",
 xl:"p-8 sm:p-10"
 },
 interactive: {
 true: [
"cursor-pointer group relative overflow-hidden",
"hover:shadow-liquid-glass-lg hover:scale-[1.02]",
"active:scale-[0.98]",
"transition-all duration-[var(--duration-morph)] ease-[var(--ease-fluid-spring)]",
"will-change-transform"
].join(""),
 false:""
 }
 },
 defaultVariants: {
 variant:"default",
 padding:"md",
 interactive: false
 }
 }
);
